import { ReactNode } from 'react';

export type MeterOptions = {
  value: number;
  name: string;
  color?: string;
  legendContent?: string;
  tooltipContent?: ReactNode;
};

export enum METER_CHART_VARIANTS {
  DEFAULT = 'default',
  COMPARISON = 'comparison',
  RELATED_BLUE = 'related blue',
  RELATED_GREEN = 'related green',
  RELATED_PURPLE = 'related purple',
}
